import { Link, useLocation } from "react-router-dom";
import { useAuth } from "react-oidc-context";
import {
  Box,
  Collapse,
  Divider,
  IconButton,
  List,
  ListItemButton,
  ListItemIcon,
  ListItemText,
  Typography,
} from "@mui/material";
import Login from "./Login";
import {
  MdCarRental,
  MdClose,
  MdElectricMeter,
  MdHouse,
  MdVerifiedUser,
  MdSettings,
} from "react-icons/md";

const Sidebar = ({ onItemClick, open, onClose, isMobile }) => {
  const location = useLocation();
  const auth = useAuth();
  const groups = auth.user?.profile?.["cognito:groups"];
  const isAdmin = groups?.includes("LexEnergy-Admin");
  const sidebarItems = [
    ["Dashboard", "/dashboard", <MdElectricMeter />],
    ["Installations", "/installations", <MdCarRental />],
    isAdmin ? ["Users", "/users", <MdVerifiedUser />] : null,
    isAdmin ? ["Organizations", "/organizations", <MdHouse />] : null,
    isAdmin ? ["Global Settings", "/settings", <MdSettings />] : null,
  ].filter((n) => n); // Filters out nulls

  return (
    <Collapse
      in={!isMobile || open}
      orientation="horizontal"
      sx={{
        position: isMobile ? "fixed" : "relative",
        zIndex: isMobile ? 1200 : 1200,
        top: 0,
        left: 0,
        p: 0,
        height: "100vh",
        bgcolor: "#222",
        color: "white",
        width: isMobile ? "250px" : undefined,
        boxShadow: isMobile ? 3 : undefined,
        "& .MuiCollapse-wrapper": {
          height: "100%",
        },
        "& .MuiCollapse-wrapperInner": {
          height: "100%",
          display: "flex",
          flexDirection: "column",
        },
      }}
    >
      <Box
        sx={{
          width: "250px",
          minWidth: "250px",
          display: "flex",
          flexDirection: "column",
          p: 3,
          bgcolor: "#222",
          color: "white",
          height: "100%",
        }}
      >
        <Box sx={{ display: "flex", alignItems: "center", pb: 3 }}>
          <Typography variant="h5" fontWeight="bold">
            LexOne
          </Typography>
          {isMobile ? (
            <IconButton onClick={onClose} sx={{ color: "white", ml: "auto" }}>
              <MdClose sx={{ color: "white" }} />
            </IconButton>
          ) : null}
        </Box>
        <List disablePadding>
          {sidebarItems.map(([label, path, icon], index) => {
            const selected = location.pathname.startsWith(path);

            return (
              <ListItemButton
                key={index}
                component={Link}
                to={path}
                onClick={() => {
                  onItemClick(label);
                  onClose(); // auto-close on mobile
                }}
                selected={selected}
                sx={{
                  borderRadius: 1,
                  mb: 1,
                  height: 30,
                  color: "white",
                  "&.Mui-selected": {
                    bgcolor: "#444",
                    fontWeight: "bold",
                  },
                  "&:hover": {
                    bgcolor: "#444",
                  },
                }}
              >
                <ListItemIcon sx={{ color: "white", mr: 1, minWidth: 25 }}>
                  {icon}
                </ListItemIcon>
                <ListItemText primary={label} />
              </ListItemButton>
            );
          })}
        </List>

        <Divider sx={{ background: "grey", mb: 1, mt: "auto" }} />
        <Login />
      </Box>
    </Collapse>
  );
};

export default Sidebar;
